import { Entity } from '@sketchpixy/rubix/lib/L20n';
import React from 'react';
import { connect } from 'react-redux';
import { initialize, submit } from 'redux-form';
import { PERMISSIONS, PERMISSION_ENTITIES, SUBSCRIPTION_TYPES } from '../../../_config/consts';
import * as UserActions from '../../../redux/actions/user.actions';
import AbilityProvider from '../../../permissionsUtils/AbilityProvider.js';
import * as ModalActions from '../../../redux/actions/modal.actions.js';
import * as SettingsActions from '../../../redux/actions/setting.actions';
import * as UtilsActions from '../../../redux/actions/utils.actions';
import { getApiBackendPrefix } from '../../../_config/conf';
import MDButton from '../../MDButton/MDButton.jsx';
import Permission from '../../Permission/Permission.jsx';
import SamlSsoConfigurationForm from '../../forms/Integrations/SamlSsoConfigurationForm.jsx';

function getDefaultAssertionConsumerUrl() {
  if (typeof window !== 'undefined' && window.location && window.location.host) {
    return `https://${getApiBackendPrefix()}${window.location.host}/api/v2/oauth/saml/callback`;
  }
  return '';
}

function getDefaultRelyingPartyIdentifier() {
  if (typeof window !== 'undefined' && window.location && window.location.host) {
    return `${window.location.protocol}//${window.location.host}/luckey`;
  }
  return '';
}

function toSamlFormValues(samlSSOConfiguration = {}) {
  return {
    metadata: samlSSOConfiguration.metadata ? samlSSOConfiguration.metadata : '',
    assertionConsumerUrl: samlSSOConfiguration.assertionConsumerUrl || getDefaultAssertionConsumerUrl(),
    relyingPartyIdentifier: samlSSOConfiguration.relyingPartyIdentifier || getDefaultRelyingPartyIdentifier(),
    exclusiveLogin: !!samlSSOConfiguration.exclusiveLogin,
    enableUserCreation: !!samlSSOConfiguration.enableUserCreation,
    firstnameMapping: samlSSOConfiguration.firstnameMapping || '',
    lastnameMapping: samlSSOConfiguration.lastnameMapping || '',
    userTagMapping: samlSSOConfiguration.userTagMapping || '',
    roleMapping: samlSSOConfiguration.roleMapping || '',
    managerRoleValue: samlSSOConfiguration.managerRoleValue || '',
    extIdMapping: samlSSOConfiguration.extIdMapping || '',
    availablePlatforms: samlSSOConfiguration.availablePlatforms || [],
  };
}

function toSamlApiPayload(values) {
  return {
    metadata: values.metadata,
    exclusiveLogin: !!values.exclusiveLogin,
    enableUserCreation: !!values.enableUserCreation,
    firstnameMapping: values.firstnameMapping || '',
    lastnameMapping: values.lastnameMapping || '',
    userTagMapping: values.userTagMapping || '',
    roleMapping: values.roleMapping || '',
    managerRoleValue: values.managerRoleValue || '',
    extIdMapping: values.extIdMapping || '',
    availablePlatforms: values.availablePlatforms || [],
  };
}

@connect((state) => ({ form: state.form.SamlSsoConfigurationForm, samlSSOConfiguration: state.settings.items.samlSSOConfiguration }))
class SamlSsoSettingsOperationSection extends React.Component {


  async componentWillMount() {
    const { dispatch, setting } = this.props;
    // FETCH SAML CONFIGURATION
    try {
      const samlSSOConfiguration = await dispatch(SettingsActions.fetchCompanySamlSSOSettings());
      dispatch(initialize('SamlSsoConfigurationForm', toSamlFormValues(samlSSOConfiguration)));
    } catch (error) {
      dispatch(initialize('SamlSsoConfigurationForm', toSamlFormValues({})));
    }
  }

  async saveSamlSsoConfiguration(values) {
    const { dispatch } = this.props;
    try {
      dispatch(UtilsActions.setSpinnerVisibile(true));
      const updatedConfiguration = await dispatch(SettingsActions.updateCompanySamlSSOSettings(toSamlApiPayload(values)));
      dispatch(initialize('SamlSsoConfigurationForm', toSamlFormValues(updatedConfiguration)));
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(SettingsActions.setOperationalMode(false));
      dispatch(ModalActions.showModal({
        modalType: 'SUCCESS_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="samlSSOConfigurationSuccess" /></h6>),
        },
      }));
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="samlSSOConfigurationError" /></h6>),
        },
      }));
    }
  }

 

  render() {
    const { dispatch, form } = this.props;
    const isOfficeSSOActive = dispatch(UserActions.userHasSubscriptions(SUBSCRIPTION_TYPES.OFFICE_SSO));
    return (
      <div style={{ paddingLeft: 20, paddingRight: 25 }}>
        <SamlSsoConfigurationForm
          formValues={form && form.values ? form.values : {}}
          isOfficeSSOActive={isOfficeSSOActive}
          onSubmit={values => this.saveSamlSsoConfiguration(values)}
        />
        <div style={{ backgroundColor: 'white', position: 'absolute', left: 0, right: 0, bottom: 0, width: '100%', margin: 0 }}>
          <Permission do={[PERMISSIONS.UPDATE]} on={PERMISSION_ENTITIES.COMPANY} abilityHelper={AbilityProvider.getAbilityHelper()}>
            <MDButton
              containerStyle={{ position: 'absolute', left: 0, right: 0, bottom: 0, width: '100%', margin: 0 }}
              style={{ height: 45, borderRadius: 0 }}
              title={<Entity entity="saveSamlSSOConfiguration" />}
              onClick={() => dispatch(submit('SamlSsoConfigurationForm'))}
            />
          </Permission>
          </div>
      </div>
    );
  }
} 

export default SamlSsoSettingsOperationSection;
